import {
  Body1Stronger,
  Button,
  Card,
  Image,
  Subtitle2Stronger,
  Text
} from '@fluentui/react-components';
import React from 'react';

import { Flex } from '@tdp/common/fluentV9MigrationComponents';

import { useOverviewCardStyles } from './AppValidationDetails.styles';


export const OverviewHeroCard: React.FC<{
  title: string;
  subtitle: string;
  imgSrc: string;
  message: string;
  buttonText: string;
  action: () => void;
  secondaryText?: string;
  secondaryAction?: () => void;
}> = ({ title, subtitle, imgSrc, message, buttonText, secondaryText, action, secondaryAction }) => {
  const classes = useOverviewCardStyles();
  return (
    <Card className={classes.card}>
      <header>
        <Body1Stronger>{title}</Body1Stronger>
      </header>
      <Flex gap="gap.large" vAlign="center" hAlign="center">
        <Flex column gap="gap.large">
          <Flex gap="gap.medium" column>
            <Subtitle2Stronger>{subtitle}</Subtitle2Stronger>
            <Text>{message}</Text>

          </Flex>
        </Flex>
        <Image src={imgSrc} alt={title} style={{ maxHeight: "184px" }} />
      </Flex>
      <footer>
        <Flex gap='gap.medium'>
          <Button appearance='primary' onClick={action} style={{ maxWidth: "118px" }}>{buttonText}</Button>
          {
            secondaryAction && secondaryText &&
            <Button appearance='secondary' onClick={secondaryAction} style={{ maxWidth: "118px" }}>
              {secondaryText}
            </Button>
          }
        </Flex>
      </footer>
    </Card>
  )
}